import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import GrievanceForm from "../components/GrievanceForm";
import "../assets/css/Grievance.css";

const Grievance = () => {
  return (
    <>
      <Navbar />

      <main className="grievance-page">
        <section className="grievance-hero">
          <div className="grievance-badge">
            SUBMIT A GRIEVANCE
          </div>

          <h1>We take every concern seriously</h1>

          <p>
            If you have a complaint or concern about our services, staff,
            or how we handle your data, please let us know using the form
            below. You can also email us directly at{" "}
            <a href="mailto:grievance@outcess.com.ng">
              grievance@outcess.com.ng
            </a>
            .
          </p>
        </section>

        <GrievanceForm />
      </main>

      <Footer />
    </>
  );
};

export default Grievance;